import { REQUEST_STATUS_COMPLETED, REQUEST_STATUS_FAILED } from '../../../share/util/api/polling';
import { executePolling } from "../../../share/util/api/polling";
import apiService from '../../../share/util/api/service';
import { PHASE } from './constants';

/** SSM4実行ファイル起動処理 */
export async function startSSM4(self) {
  try {
    self.isLoading = true;
    const response = await executePolling(
      self,
      // POST API 呼び出しのコールバック
      async () => {
        return await apiService.postCall(
          apiService.DIAG,
          `/netApps/${self.netAppId}/diag/startSSM4`,
        );
      },
      // GET API 呼び出しのコールバック
      async (postApiResponse) => {
        return await apiService.getCall(
          apiService.DIAG,
          `/netApps/${self.netAppId}/diag/requests/${postApiResponse.data.request_id}`,
        );
      },
      // エラー発生のコールバック
      (errorType) => { errorType; self.showUnexpectedError(PHASE.START_SSM4_ERROR); },
      // POST API レスポンスチェックのコールバックはデフォルト処理を使用
      undefined,
      // GET API レスポンスチェックのコールバックはデフォルト処理を使用
      undefined,
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
      (result) => { self.validateErrorResult(result, PHASE.START_SSM4_ERROR); },
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
      (result) => { self.validateErrorResult(result, PHASE.START_SSM4_ERROR); },
    );

    if (response) {
      // 正常コールバック
      switch (response.data.status) {
        case REQUEST_STATUS_COMPLETED:
          // 正常終了
          // SSM5 完全ログアウト処理
          self.SSM5Logout();
          break;
        case REQUEST_STATUS_FAILED:
        default:
          // 異常終了
          // SSM4起動失敗画面に遷移
          self.showUnexpectedError(PHASE.START_SSM4_ERROR);
          break;
      }
    }
  } finally {
    self.isLoading = false;
  }
}